import {Component, Input} from "@angular/core";
import {EditService} from "../../framework/entity/edit/edit-page/edit.service";
import {FormGroup} from "@angular/forms";
import {AddressData} from "../address.data";

@Component({
    selector: "wbo-address-edit",
    templateUrl: "./address-edit.component.html",
    styleUrls: ["./address-edit.component.scss"]
})
export class AddressEditComponent {
    @Input() formGroupAddress: FormGroup;
    @Input() address: AddressData;
    @Input() showCountry: boolean = true;
    @Input() readonly: boolean = false;

    constructor(public editService: EditService) {
    }
}
